import {
    FETCH_LOYALTY_PROGRAM_CAMPAIGNS,
    SAVE_CAMPAIGN,
    CLOSE_CAMPAIGN,
    DELETE_CAMPAIGN
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_LOYALTY_PROGRAM_CAMPAIGNS:
            return action.payload;
        case SAVE_CAMPAIGN:
            if (action.meta && action.meta.campaignId) {
                return state.map(campaign => campaign.id === action.meta.campaignId ? action.payload : campaign);
            }
            return state.concat(action.payload);
        case CLOSE_CAMPAIGN:
            return state.map(campaign => campaign.id === action.meta.campaignId ? action.payload : campaign);
        case DELETE_CAMPAIGN:
            return state.filter(campaign => campaign.id !== action.meta.campaignId);
        default:
            return state;
    }
};
